
import { imgSuffix } from '../../util/inspiration';
import { useHover } from 'ahooks';
import React, { useRef, useState } from 'react';
import './index.less';
import { SimpleImg } from 'react-simple-img';

const Index = ({
  data
}) => {
  const [clickCaseId, setClickCaseId] = useState(0);
  const ref = useRef();
  const isHovering = useHover(ref);
  return (
    <div
      ref={ref}
      className='caseCardContainer'
      onClick={() => {

      }}
    >
      <div className='cover'>
        <a href='#!' title={data.titleOrigin}>
          <SimpleImg
            width={248}
            height={310}
            importance={'high'}
            animationDuration={0.2}
            src={`${data.cover}${imgSuffix(248, 310)}`}
            alt=''
            className='coverImg'
          />
        </a>

      </div>
      <div className='subInfo'>
        <div className='title'>
          {data?.titleOrigin && (
            <div className='titleOrigin'>
              <a href='#!' title={data.titleOrigin}>
                {data.titleOrigin}
              </a>
            </div>
          )}
        </div>
        {/* {
          <div className='footer'>
            <div className='author'>
              <span>{data.country}</span>
            </div>
            <div className='checkAndCollect'>
              <div className='check'>
                <span>{'共' + data.periodicalNum + '期'}</span>
              </div>
            </div>
          </div>
        } */}
      </div>
    </div >
  );
};

export default Index;
